var FontAlignments;
(function (FontAlignments) {
  FontAlignments["Center"] = 'center';
  FontAlignments["Left"] = 'left';
  FontAlignments["Right"] = 'right';
})(FontAlignments || (FontAlignments = {}));
var FontColors;
(function (FontColors) {
  FontColors["Default"] = 'default';
  FontColors["Primary"] = 'primary';
  FontColors["Warning"] = 'warning';
})(FontColors || (FontColors = {}));
var FontDecorations;
(function (FontDecorations) {
  FontDecorations["Dotted"] = 'dotted';
  FontDecorations["None"] = 'none';
  FontDecorations["Underline"] = 'underline';
})(FontDecorations || (FontDecorations = {}));
var FontSizes;
(function (FontSizes) {
  FontSizes["Large"] = 'large';
  FontSizes["Medium"] = 'medium';
  FontSizes["Small"] = 'small';
  FontSizes["XLarge"] = 'xlarge';
  FontSizes["XSmall"] = 'xsmall';
  FontSizes["XxLarge"] = 'xxlarge';
  FontSizes["XxSmall"] = 'xxsmall';
})(FontSizes || (FontSizes = {}));
var FontTransforms;
(function (FontTransforms) {
  FontTransforms["Capitalize"] = 'capitalize';
  FontTransforms["Lowercase"] = 'lowercase';
  FontTransforms["None"] = 'none';
  FontTransforms["Uppercase"] = 'uppercase';
})(FontTransforms || (FontTransforms = {}));
var FontWeights;
(function (FontWeights) {
  FontWeights["Bold"] = 'bold';
  FontWeights["Book"] = 'book';
  FontWeights["Medium"] = 'medium';
})(FontWeights || (FontWeights = {}));
export { FontAlignments, FontColors, FontDecorations, FontSizes, FontTransforms, FontWeights };